var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
var Addon = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  flex-shrink: 1;\n  justify-content: center;\n  padding: ", " ", ";\n\n  &.btn-addon {\n    align-items: stretch;\n    display: flex;\n    margin: 0;\n    padding: 0;\n    & > .btn {\n      border-radius: inherit;\n      box-shadow: none;\n      z-index: 1; /* could cause problems? */\n      &:focus {\n        box-shadow: 0 0 0 2px\n          ", ";\n      }\n    }\n  }\n"], ["\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  flex-shrink: 1;\n  justify-content: center;\n  padding: ", " ", ";\n\n  &.btn-addon {\n    align-items: stretch;\n    display: flex;\n    margin: 0;\n    padding: 0;\n    & > .btn {\n      border-radius: inherit;\n      box-shadow: none;\n      z-index: 1; /* could cause problems? */\n      &:focus {\n        box-shadow: 0 0 0 2px\n          ", ";\n      }\n    }\n  }\n"])), function (p) {
  return p.theme.colorLevel(p.theme.lowContrast, 2);
}, function (p) {
  return p.theme.highContrast;
}, function (p) {
  return p.theme.inputPaddingY;
}, function (p) {
  return p.theme.inputPaddingX;
}, function (p) {
  return p.brand ? p.theme.colorLevel(p.theme[p.brand], -5) : p.theme.textPrimary;
});

var InputAddon = function InputAddon(_a) {
  var children = _a.children,
      _b = _a.button,
      button = _b === void 0 ? false : _b,
      _c = _a.brand,
      brand = _c === void 0 ? 'primary' : _c,
      props = __rest(_a, ["children", "button", "brand"]);

  return React.createElement(Addon, Object.assign({
    className: "input-group-addon" + (button ? ' btn-addon' : ''),
    brand: brand
  }, props), children);
};

export default InputAddon;
var templateObject_1;